import { useEffect } from 'react';
import { RiRefreshLine, RiShieldCheckLine } from 'react-icons/ri';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { useStore } from '../../state/store';
import { formatDate } from '@/lib/utils';

export function AuditPanel() {
  const audit = useStore(state => state.audit);
  const refreshAudit = useStore(state => state.refreshAudit);
  const activeEngagementId = useStore(state => state.activeEngagementId);

  useEffect(() => {
    if (activeEngagementId) refreshAudit();
  }, [activeEngagementId, refreshAudit]);

  return (
    <div className="flex flex-col gap-2.5 p-3">
      <div className="flex items-center justify-between">
        <span className="label-caps">工作日志</span>
        <Button size="xs" variant="ghost" onClick={() => refreshAudit()}>
          <RiRefreshLine className="size-3" />
          刷新
        </Button>
      </div>

      <div className="flex items-center gap-1.5 rounded-[var(--radius)] border border-border bg-muted/40 p-2 text-[10.5px] text-muted-foreground">
        <RiShieldCheckLine className="size-3.5 shrink-0 text-[var(--color-evidence)]" />
        采集、研判与写操作全程留痕，可追溯。
      </div>

      <div className="flex flex-col">
        {audit.map(entry => (
          <div key={entry.id} className="border-b border-border py-2 last:border-b-0">
            <div className="flex items-center justify-between gap-2">
              <span className="font-mono text-[10.5px] text-primary">{entry.action}</span>
              <span className="shrink-0 text-[9.5px] text-muted-foreground">{formatDate(entry.at)}</span>
            </div>
            <div className="mt-1 flex flex-wrap items-center gap-1.5">
              {entry.objectType && <Badge variant="muted">{entry.objectType}</Badge>}
              {entry.objectId && (
                <span className="truncate font-mono text-[9.5px] text-muted-foreground">{entry.objectId}</span>
              )}
              {entry.actor && <span className="text-[9.5px] text-muted-foreground">· {entry.actor}</span>}
            </div>
            {entry.detail != null && (
              <pre className="mt-1 max-h-32 overflow-auto whitespace-pre-wrap break-all rounded-[var(--radius-sm)] bg-muted/40 p-1.5 font-mono text-[9.5px] text-muted-foreground">
                {JSON.stringify(entry.detail, null, 1).slice(0, 420)}
              </pre>
            )}
          </div>
        ))}
      </div>

      {audit.length === 0 && (
        <div className="rounded-[var(--radius)] border border-dashed border-border p-6 text-center text-[11.5px] text-muted-foreground">
          暂无日志。
        </div>
      )}
    </div>
  );
}